import { Yup } from '../../../helpers/yup';

export const schemaClaimInsert = Yup.object().shape({
  warrantyCode: Yup.string().required(
    'ไม่พบรหัสรับประกัน กรุณาปิดแล้วหน้าเว็บแล้วเข้าใหม่อีกครั้ง',
  ),
  breakdownId: Yup.number().typeError('กรุณาเลือกอาการเสีย').required('กรุณาเลือกอาการเสีย'),
  claimImage: Yup.array()
    .required('กรุณาถ่ายหรือแนบภาพสินค้าที่ต้องการเคลม')
    .min(1, 'กรุณาถ่ายหรือแนบภาพสินค้าที่ต้องการเคลม'),
});
